import React from 'react';

const ProfilePlusIcon = ({ className }) => (
    <svg
        width='28'
        height='28'
        viewBox='0 0 28 28'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <circle cx='14' cy='14' r='14' fill='#00225F' />
        <path
            d='M8.66699 13.8333H19.0003M13.8337 8.66663V19'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export { ProfilePlusIcon };
